<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="currentColor"><path d="M2 26L30 16 2 6 2 14l18 2-18 2z"/></svg>
